export const API_ENV_URLS = Object.freeze({
  backend:
    process.env.REACT_APP_BACKEND_URL_LOCAL ||
    process.env.REACT_APP_BACKEND_URL,
  nebula: process.env.REACT_APP_NEBULA_API_URL,
  crifBureauPull: process.env.REACT_APP_CRIF_BUREAU_PULL_URL,
  crifBureauReports: process.env.REACT_APP_CRIF_BUREAU_REPORTS_URL,
  crifBureauReportsCallcentre:
    process.env.REACT_APP_CRIF_BUREAU_REPORTS_CALLCENTRE_URL,
  dedupeCheck: process.env.REACT_APP_DEDUPE_CHECK_URL,
  sarvam: process.env.REACT_APP_SARVAM_API_BASE_URL,
});

export const API_ENDPOINTS = Object.freeze({
  auth: Object.freeze({
    me: "/api/me",
  }),
  pilInfo: Object.freeze({
    search: "/api/pilinfo/search",
  }),
  inbound: Object.freeze({
    metadata: "/api/inbound/metadata",
    history: "/api/inbound/history",
    entries: "/api/inbound/entries",
    assignUrgent: "/api/inbound/assign-urgent",
  }),
  eligibilityCheck: Object.freeze({
    list: "/api/eligibility-check/list",
    options: "/api/eligibility-check/options",
    resultForm: "/api/eligibility-check/result-form",
    result: "/api/eligibility-check/result",
    search: "/api/eligibility-check/search",
  }),
  welcomeLetter: Object.freeze({
    preview: (loanAccountNumber) =>
      `/api/welcome-letter/${encodeURIComponent(loanAccountNumber)}`,
    pdf: (loanAccountNumber) =>
      `/api/welcome-letter/${encodeURIComponent(loanAccountNumber)}/pdf`,
  }),
  telecallingRecords: Object.freeze({
    dashboard: "/api/telecalling-records",
    metadata: "/api/telecalling-records/metadata",
    summary: "/api/telecalling-records/summary",
    list: "/api/telecalling-records/list",
    search: "/api/telecalling-records/search",
    callEntry: "/api/telecalling-records/call-entry",
    acknowledgeNotification:
      "/api/telecalling-records/notifications/acknowledge",
    dailyAssignment: Object.freeze({
      metadata: "/api/telecalling-records/daily-assignment/metadata",
      search: "/api/telecalling-records/daily-assignment/search",
      assign: "/api/telecalling-records/daily-assignment/assign",
    }),
  }),
  liveDashboard: Object.freeze({
    summary: "/api/reports/live-dashboard",
  }),
  application: Object.freeze({
    summarySearch: "/v2/application/summary/search",
    details: (applicationId) =>
      `/application?applicationId=${encodeURIComponent(applicationId)}`,
  }),
  userManagement: Object.freeze({
    users: "/api/user-management/users",
    options: "/api/user-management/users/options",
    rules: (id) => `/api/user-management/users/${id}/rules`,
    user: (id) => `/api/user-management/users/${id}`,
  }),
});

export const API_ERROR_MESSAGES = Object.freeze({
  backendUrlNotConfigured: "REACT_APP_BACKEND_URL is not configured.",
  nebulaUrlNotConfigured: "REACT_APP_NEBULA_API_URL is not configured.",
  authenticatedUsernameMissing:
    "Authenticated username is not available. Please login again.",
  authenticatedAccessTokenMissing:
    "Authenticated access token is not available. Please login again.",
  currentUserReadFailed: "Unable to read current user response.",
  currentUserLoadFailed: "Unable to load current user access.",
  pilInfoReadFailed: "Unable to read PIL info response.",
  pilInfoFetchFailed: "Unable to fetch PIL info.",
  inboundMetadataReadFailed: "Unable to read inbound metadata response.",
  inboundMetadataFetchFailed: "Unable to fetch inbound metadata.",
  inboundHistoryReadFailed: "Unable to read inbound history response.",
  inboundHistoryFetchFailed: "Unable to fetch inbound history.",
  inboundEntryReadFailed: "Unable to read inbound entry response.",
  inboundEntrySaveFailed: "Unable to save inbound entry.",
  inboundUrgentReadFailed: "Unable to read urgent assignment response.",
  inboundUrgentAssignFailed: "Unable to assign inbound contact urgently.",
  eligibilityListReadFailed: "Unable to read eligibility check list response.",
  eligibilityListFetchFailed: "Unable to fetch eligibility checks.",
  eligibilityOptionsReadFailed:
    "Unable to read eligibility check options response.",
  eligibilityOptionsFetchFailed: "Unable to fetch eligibility options.",
  eligibilitySearchReadFailed: "Unable to read eligibility check response.",
  eligibilityDetailsFetchFailed: "Unable to fetch eligibility details.",
  eligibilityResultFormReadFailed:
    "Unable to read eligibility result form response.",
  eligibilityResultFormFetchFailed: "Unable to fetch eligibility result form.",
  eligibilityResultSaveReadFailed:
    "Unable to read eligibility result save response.",
  eligibilityResultSaveFailed: "Unable to save eligibility result.",
  welcomeLetterPreviewReadFailed: "Unable to read Welcome Letter response.",
  welcomeLetterPreviewFetchFailed: "Unable to retrieve Welcome Letter details.",
  welcomeLetterPdfDownloadFailed: "Unable to generate the Welcome Letter PDF.",
  welcomeLetterInvalidPdf: "The server did not return a valid PDF.",
  telecallingMetadataReadFailed:
    "Unable to read telecalling metadata response.",
  telecallingMetadataFetchFailed: "Unable to fetch telecalling metadata.",
  telecallingSummaryReadFailed: "Unable to read telecalling summary response.",
  telecallingSummaryFetchFailed: "Unable to fetch telecalling summary.",
  telecallingListReadFailed:
    "Unable to read telecalling records list response.",
  telecallingListFetchFailed: "Unable to fetch telecalling records.",
  telecallingSearchReadFailed: "Unable to read telecalling search response.",
  telecallingSearchFailed: "Unable to search telecalling record.",
  applicationSearchReadFailed:
    "Unable to read application summary search response.",
  applicationSearchFailed: "Unable to search application by phone number.",
  applicationNotFound: "No application found for this phone number.",
  applicationDetailsReadFailed: "Unable to read application details response.",
  applicationDetailsFetchFailed: "Unable to fetch application details.",
  telecallingCallEntryReadFailed:
    "Unable to read telecalling call entry response.",
  telecallingCallEntrySaveFailed: "Unable to save telecalling call entry.",
  telecallingNotificationReadFailed:
    "Unable to read telecalling notification response.",
  telecallingNotificationFetchFailed:
    "Unable to fetch telecalling notifications.",
  telecallingNotificationAcknowledgeReadFailed:
    "Unable to read telecalling notification acknowledgement response.",
  telecallingNotificationAcknowledgeFailed:
    "Unable to acknowledge telecalling notification.",
  dailyAssignmentMetadataReadFailed:
    "Unable to read daily assignment metadata response.",
  dailyAssignmentMetadataFetchFailed:
    "Unable to load daily assignment metadata.",
  dailyAssignmentSearchReadFailed:
    "Unable to read daily assignment search response.",
  dailyAssignmentSearchFailed: "Unable to search the daily assignment pool.",
  dailyAssignmentAssignReadFailed: "Unable to read daily assignment response.",
  dailyAssignmentAssignFailed: "Unable to assign the selected contacts.",
  liveDashboardReadFailed: "Unable to read live dashboard response.",
  liveDashboardFetchFailed: "Unable to fetch live dashboard.",
  userManagementUsersReadFailed:
    "Unable to read user management users response.",
  userManagementUsersFetchFailed: "Unable to fetch user management users.",
  userManagementOptionsReadFailed:
    "Unable to read user management options response.",
  userManagementOptionsFetchFailed: "Unable to fetch user management options.",
  userManagementRulesReadFailed:
    "Unable to read user assignment rules response.",
  userManagementRulesFetchFailed: "Unable to fetch user assignment rules.",
  userManagementUpdateReadFailed:
    "Unable to read user management update response.",
  userManagementUpdateFailed: "Unable to update user.",
  crifReportsUrlNotConfigured:
    "REACT_APP_CRIF_BUREAU_REPORTS_URL is not configured.",
  crifPullUrlNotConfigured: "REACT_APP_CRIF_BUREAU_PULL_URL is not configured.",
  dedupeCheckUrlNotConfigured: "REACT_APP_DEDUPE_CHECK_URL is not configured.",
  dedupeCheckReadFailed: "Unable to read dedupe check response.",
  dedupeCheckFetchFailed: "Unable to fetch dedupe check.",
  crifPullReadFailed: "Unable to read CRIF bureau response.",
  crifPullFetchFailed: "Unable to fetch CRIF bureau report.",
  crifReportsReadFailed: "Unable to read saved CRIF reports response.",
  crifReportsFetchFailed: "Unable to fetch saved CRIF reports.",
});
